module.exports = __webpack_public_path__ + "img/troyers-logo.86a14893.png";